VideoMediaTabStore = LP.module('VideoMediaTabStore')
LpBoclips = LP.module('LpBoclips')
require('../components/boclips_modal')

BoclipsModal = LP.module('LpBoclips').BoclipsModal
class VideoMediaTabStore extends FluxBaseStore
  @storeName: 'VideoMediaTabStore'

  @handlers:
    SHOW_RESOURCE: 'show'
    HIDE_RESOURCE: 'hide'

  show: ({url, transition, videoUrl, type, noHistory, fromBackButton}) ->
    self = this
    @dispatcher.waitFor ['ResourceStore', 'RouteStore'], ->
      return if !url? || String(type) != 'boclips_video'
      new BoclipsModal(
        url,
        videoUrl,
        {},
        transition
      ).show()

  hide: ({query, noHistory, fromBackButton} = {query: null, noHistory: null, fromBackButton: null}) ->
    self = this
    @dispatcher.waitFor ['RouteStore'], ->
      BoclipsModal.hide()

LpBoclips.VideoMediaTabStore = VideoMediaTabStore
